import { SelectOption } from 'tailwindComponents/selectTW/interfaces';
import { eSigningMethod } from './eSigningMethod';
import { IDetailsFormData } from 'components/order/scheduling/CreateSigningAppointment/01_detailsStep/detailsForm/types/IDetailsFormData';
import { isDigitalSchedulingOwnerType } from '../order/consumer/eCreateSigningAppointmentFormDataOwnerTypes';
import { labelComparator } from '../../utilities/labelComparator';

export interface ISigningMethodResponse {
  id: string;
  label: string;
  description?: string;
  isActive: boolean;
}

export const getSigningMethodOptions = (
  signingMethods: ISigningMethodResponse[],
  values?: IDetailsFormData
): SelectOption[] => {
  const filter = filterAttorneyAndNotaryWhenDSS(values);
  return signingMethods.filter(filter).map(mapper).sort(comparator);
};

const methodsWithEmailConfirmation = new Set<string>(['attorney', 'notary']);
const isMethodWithEmailConfirmation = (method: ISigningMethodResponse) => {
  return methodsWithEmailConfirmation.has(method.id);
};

const filterAttorneyAndNotaryWhenDSS = (values?: IDetailsFormData): ((m: ISigningMethodResponse) => boolean) => {
  if (isDigitalSchedulingOwnerType(values?.ownerType)) {
    return isMethodWithEmailConfirmation;
  }
  return () => true;
};

const mapper = (method: ISigningMethodResponse): SelectOption => ({
  label: method.label,
  value: method.id,
});

const comparator = (a: SelectOption, b: SelectOption): number => {
  if (a.value === eSigningMethod.notaryOnly) {
    return -1;
  }
  if (b.value === eSigningMethod.notaryOnly) {
    return 1;
  }
  return labelComparator(a, b);
};

export const getSigningMethodDescriptions = (signingMethods: ISigningMethodResponse[]): Record<string, string> =>
  signingMethods.reduce((descriptionsById, method) => {
    descriptionsById[method.id] = method.description;
    return descriptionsById;
  }, {});
